<template>
  <section
    v-show="hasProducts"
    class="sb-recent-panel"
    :style="cssVars"
    :class="{
      'shopbox-left-disabled': page == 0,
      'shopbox-right-disabled': page > 1,
    }"
  >
    <h1>{{ store.state.content[store.state.lang].panels.recent }}</h1>
    <ul class="hs full" v-on:scroll.passive="handleScroll">
      <li
        class="sb-item"
        v-for="(product, i) in store.state.embedRecentProducts"
        :key="i"
      >
        <a @click="emitUserDetails(product.sku, product.url)">
          <img width="140" height="140" :src="product.imageUrl" />
        </a>
        <div class="sb-item--details">
          <a @click="emitUserDetails(product.sku, product.url)">
            <div class="sb-clamp">
              <h1>{{ product.name }}</h1>
            </div>
            <!-- <span class="sb-sku">{{ product.sku }}</span> -->
            <template v-if="product.inc_vat">
              <p class="price">
                <span
                  v-if="product.priceFrom == true"
                  style="font-weight: bold !important; margin: 0 2px"
                  >from</span
                >
                {{ store.state.currency }}{{ product.price }}
                <span
                  style="
                    font-size: 12px !important;
                    font-weight: 600 !important;
                    margin: 0 2px;
                  "
                  >Ex VAT.</span
                >
              </p>
              <p class="price">
                {{ store.state.currency }}{{ product.inc_vat }}
                <span
                  style="
                    font-size: 12px !important;
                    font-weight: 600 !important;
                    margin: 0 2px;
                  "
                  >Inc. VAT.</span
                >
              </p>
            </template>
            <template v-else>
              <p
                class="price"
                v-if="
                  product.price == 0 && store.state.client == 'buildfourless'
                "
              >
                <a
                  href="tel:020-3481-1978"
                  style="text-decoration: underline; min-height: 40px"
                >
                  Call for price</a
                >
              </p>
              <p class="price" v-else>
                <template v-if="store.state.currency == 'kr.'">
                  {{ addZeroes(product.price) }} {{ store.state.currency }}
                </template>
                <template v-else>
                  {{ store.state.currency }} {{ addZeroes(product.price) }}
                </template>
              </p>
            </template>
          </a>
          <div class="btn-wrap">
            <a
              class="product-btn shopbox-find-similar sb-findsim-v2"
              @click="toggleSimilar(product.sku)"
              >Find Similar</a
            >
          </div>
        </div>
      </li>
    </ul>
    <span class="sb-embed-arrow sb-embed-right" @click="scrollRight"
      >&#8250;</span
    >
    <span class="sb-embed-arrow sb-embed-left" @click="scrollLeft"
      >&#8249;</span
    >
    <a href="https://www.shopbox.ai/" target="_blank" class="branding">
      powered by Shopbox
    </a>
  </section>
</template>

<script>
export default {
  props: ["store", "maincolor", "sku"],
  data() {
    return {
      hasProducts: false,
      page: 0,
      ran: false,
    };
  },
  watch: {
    "store.state.embedRecentProducts"(newVal) {
      if (newVal.length > 3) {
        this.hasProducts = true;
      }
    },
  },
  computed: {
    cssVars() {
      let mc =
        this.maincolor && this.maincolor != "null" ? this.maincolor : "#083d77";
      return {
        "--shopbox-main": mc,
      };
    },
  },
  methods: {
    addZeroes: function (num) {
      const dec = num.toString().split(".")[1];
      const len = dec && dec.length > 2 ? dec.length : 2;
      if (this.decimalcomma == true) {
        return Number(num)
          .toFixed(len)
          .replace(/\d(?=(\d{3})+\.)/g, "$&,");
      } else {
        if (this.store.state.client == "designyard") {
          return Number(num)
            .toFixed(len)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,")
            .split(".")[0];
        } else {
          return Number(num)
            .toFixed(len)
            .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        }
      }
    },
    handleScroll(s) {
      let scrollStep = document.querySelector(".hs").scrollWidth / 3;
      let currentScrollLeft = s.target.scrollLeft;
      let isMobile = window.innerWidth <= 640;
      if (isMobile) {
        scrollStep = document.querySelector(".hs").scrollWidth / 12;
      }
      if (currentScrollLeft < 100) {
        // console.log("0", scrollStep, currentScrollLeft);
        this.page = 0;
      } else if (
        currentScrollLeft >
        document.querySelector(".hs").scrollWidth - scrollStep * 2
      ) {
        this.page = 2;
      } else {
        this.page = 1;
      }

      if (currentScrollLeft > scrollStep / 3 && this.ran == false) {
        this.ran = true;
        this.store.dispatch("emitEvent", {
          data: {
            page: this.store.state.c_page,
            productid: "",
            sbAction: `Scroll`,
            site: this.store.state.client,
            source: "RecentEmbed",
            uuid: this.store.state.uuid,
          },
          headers: {},
          type: "sbaction",
        });
      }
    },
    mountEmbed() {
      this.toggleRecent();
    },
    scrollRight() {
      let el = document.querySelector(".hs");
      let scrollWidth = el.scrollWidth;
      let scrollStep = scrollWidth / 3;
      let isMobile = window.innerWidth <= 640;
      if (isMobile) {
        scrollStep = scrollWidth / 12;
      }
      if (el.scrollLeft > 0 && el.scrollLeft < scrollStep - 1) {
        // el.scrollLeft = scrollStep;
        el.scroll({
          top: 0, // could be negative value
          left: scrollStep,
          behavior: "smooth",
        });
      } else if (el.scrollLeft >= scrollStep && !isMobile) {
        el.scroll({
          top: 0, // could be negative value
          left: scrollStep * 3,
          behavior: "smooth",
        });
        // el.scrollLeft = scrollStep * 3;
      } else {
        el.scrollBy({
          top: 0, // could be negative value
          left: scrollStep,
          behavior: "smooth",
        });
        // el.scrollLeft += scrollStep;
      }
      this.store.dispatch("emitEvent", {
        data: {
          page: this.store.state.c_page,
          productid: "",
          sbAction: `Next`,
          site: this.store.state.client,
          source: "RecentEmbed",
          uuid: this.store.state.uuid,
        },
        headers: {},
        type: "sbaction",
      });

      this.page = this.page == 2 ? 2 : this.page + 1;
    },
    scrollLeft() {
      let el = document.querySelector(".hs");
      let scrollWidth = el.scrollWidth;
      let isMobile = window.innerWidth <= 640;
      let scrollStep = scrollWidth / 3;
      if (isMobile) {
        scrollStep = scrollWidth / 12;
      }
      if (el.scrollLeft < scrollStep) {
        el.scrollBy({
          top: 0, // could be negative value
          left: -el.scrollLeft,
          behavior: "smooth",
        });
        // el.scrollLeft = 0;
      } else {
        el.scrollBy({
          top: 0, // could be negative value
          left: -scrollStep,
          behavior: "smooth",
        });
        // el.scrollLeft -= scrollStep;
      }
      this.store.dispatch("emitEvent", {
        data: {
          page: this.store.state.c_page,
          productid: "",
          sbAction: `Prev`,
          site: this.store.state.client,
          source: "RecentEmbed",
          uuid: this.store.state.uuid,
        },
        headers: {},
        type: "sbaction",
      });
      this.page = this.page == 0 ? 0 : this.page - 1;
    },
    toggleRecent() {
      const data = {
        uuid: this.store.state.uuid,
        site: this.store.state.client,
        noProducts: 12,
        page: 1,
      };
      if (this.store.state.currencyCode) {
        data["currency"] = this.store.state.currencyCode;
      }
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        clientID: this.store.state.client,
      };
      this.store.dispatch("fetchProducts", {
        toggle: false,
        force: true,
        reset: true,
        panel: "embedRecent",
        data: data,
        headers: headers,
      });
    },
    toggleSimilar(sku, numProducts, panel) {
      const filters = this.getDetailsFilters();
      const data = {
        brandR: false,
        page: 1,
        numProducts: numProducts || 3,
        priceR: this.store.state.pricer,
        productid: sku,
        site: this.store.state.client,
        uuid: this.store.state.uuid,
      };
      if (this.store.state.currencyCode) {
        data["currency"] = this.store.state.currencyCode;
      }
      filters.forEach((filter) => {
        if (filter) {
          let f = JSON.parse(filter);
          data[f.name] = parseInt(f.data);
        }
      });
      const headers = {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        clientID: this.store.state.client,
      };

      this.store.dispatch("emitEvent", {
        data: {
          page: this.store.state.c_page,
          productid: sku,
          sbAction: `FindSimilar`,
          site: this.store.state.client,
          source: "RecentEmbed",
          uuid: this.store.state.uuid,
        },
        headers: {},
        type: "sbaction",
      });
      this.store.dispatch("fetchProducts", {
        toggle: true,
        force: true,
        reset: true,
        panel: panel || "similar",
        data: data,
        headers: headers,
      });
    },
    emitUserDetails(id, url) {
      this.store
        .dispatch("emitEvent", {
          data: {
            productid: id,
            site: this.store.state.client,
            uuid: this.store.state.uuid,
            sbAction: `Details`,
            page: this.store.state.c_page,
            source: "RecentEmbed",
          },
          headers: {},
          type: "sbaction",
        })
        .then(() => {
          window.location = url;
        });
    },
  },
  mounted() {
    this.mountEmbed();
  },
};
</script>

<style scoped>
.sb-recent-panel {
  padding: var(--gutter) 0;
  display: grid;
  grid-gap: var(--gutter) 0;
  grid-template-columns: var(--gutter) 1fr var(--gutter);
  align-content: start;
  --gutter: 30px;
  max-width: 1300px;
  width: 100%;
  margin: 30px auto;
  background: #f9f9f9;
  border-radius: 2px;
  position: relative;
  overflow: hidden;
}

.sb-recent-panel > * {
  grid-column: 2 / -2;
}
.sb-recent-panel h1 {
  text-align: center;
  font-size: 18px;
}
.sb-recent-panel .sb-item h1 {
  font-size: 1.1rem !important;
}

.sb-recent-panel > .full {
  grid-column: 1 / -1;
}

.hs {
  /* display: flex; */
  /* flex-wrap: nowrap; */
  display: grid;
  grid-gap: calc(var(--gutter) / 2);
  grid-template-columns: 10px;
  grid-template-rows: minmax(150px, 1fr);
  grid-auto-flow: column;
  grid-auto-columns: calc(28% - var(--gutter) * 2);

  overflow-x: scroll;
  /* scroll-snap-type: x proximity; */
  padding: 0 var(--gutter);
  padding-bottom: calc(0.75 * var(--gutter));
  min-height: 400px;
  margin-bottom: calc(-0.25 * var(--gutter));
  -ms-overflow-style: none;
  scrollbar-width: none;
  /* scroll-behavior: smooth; */
}

.hs::-webkit-scrollbar {
  display: none;
}
.hs img {
  object-fit: contain;
  margin-bottom: 10px;
  cursor: pointer;
}
.hs:before,
.hs:after {
  content: "";
  width: var(--gutter);
}
.hs .sb-item {
  /* scroll-snap-align: center; */
  padding: calc(var(--gutter) / 2 * 1.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 2px;
}
@media (max-width: 768px) {
  .hs {
    grid-auto-columns: calc(100% - var(--gutter) * 2);
    -ms-overflow-style: auto; /* Internet Explorer 10+ */
    scrollbar-width: auto; /* Firefox */
  }
  .hs::-webkit-scrollbar {
    display: block; /* Safari and Chrome */
  }
  .sb-recent-panel .sb-embed-right {
    right: calc(var(--gutter) * -0.8);
  }
  .sb-recent-panel .sb-embed-left {
    left: calc(var(--gutter) * -0.8);
  }
}
.price {
  font-size: 1.2rem;
  font-weight: bold;
  flex-direction: row !important;
}
.product-btn {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #000;
  border-radius: 2px;
  padding: 6px 0;
  margin: 4px auto;
  transition: all 0.2s ease-out;
  cursor: pointer;
  color: #000;
}
.product-btn:hover {
  color: #fff;
  background: #000;
}
.branding {
  position: absolute;
  bottom: 4px;
  right: 4px;
  font-size: 0.8rem;
  opacity: 0.6;
  cursor: pointer;
}
.sb-sku {
  font-size: 1rem;
}
.sb-embed-left {
  left: -28px;
}
.sb-embed-right {
  right: -28px;
}
.sb-embed-arrow {
  position: absolute;
  top: calc(50% - 32px);
  border-radius: 2px;
  background: #fff;
  width: 24px;
  height: 64px;
  box-shadow: 0 1px 4px 0 rgba(117, 141, 166, 0.3142);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  font-size: 38px;
  line-height: 16px;
  font-family: monospace !important;
  padding-bottom: 6px !important;
  z-index: 2147483630;
}
.hs .sb-clamp > h1 {
  position: relative;
  margin: 0;
  padding: 0;
  line-height: 1.2rem;
  font-size: 1rem;
  font-weight: normal;
  text-transform: none;
  text-align: left;
  height: 2.4rem;
  overflow: hidden;
}
.shopbox-right-disabled .sb-embed-right {
  cursor: default;
  background: #ddd;
  pointer-events: none;
}
.shopbox-left-disabled .sb-embed-left {
  cursor: default;
  background: #ddd;

  pointer-events: none;
}
</style>
